import React from 'react';
import './InviteCodeButton.css';

interface InviteCodeButtonProps {
    onClick: () => void;
    text?: string;
}

export const InviteCodeButton: React.FC<InviteCodeButtonProps> = ({
    onClick,
    text = "📨 초대 코드가 있으신가요?"
}) => {
    return (
        <button className="home-invite-code-button" onClick={onClick}>
            {text}
        </button>
    );
};
